/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefProjectData } from '../../models/api-def-project-data';

export interface OrganizationsReorderMarkdowns$Params {

/**
 * The ID of the organization to reorder the markdown versions in
 */
  organizationId: string;

/**
 * The ID of the project to reorder the markdown versions in
 */
  projectId: string;
      body: {
'order': Array<string>;
}
}

export function organizationsReorderMarkdowns(http: HttpClient, rootUrl: string, params: OrganizationsReorderMarkdowns$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsReorderMarkdowns.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('projectId', params.projectId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'project'?: ApiDefProjectData;
      }>;
    })
  );
}

organizationsReorderMarkdowns.PATH = '/organizations/{organizationId}/projects/{projectId}/reorderMarkdowns';
